import { defineMessages } from 'react-intl';

export const CATEGORICAL_MESSAGES = defineMessages({
  downloadAsCsv: {
    id: 'lCYAKjQqWpqlsSEs',
    defaultMessage: 'Download as CSV',
    description:
      'Text in a tooltip shown when hovering the "Download data" button in the categorical bar chart toolbar',
  },
});
